// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import {application} from "./application"
import {CounterController} from "./counter_controller";
import {RefreshController} from "./refresh_controller";
import {FilterController} from "./filter_controller";

application.register("refresh", RefreshController)
application.register("counter", CounterController)
application.register("filter", FilterController)
